// BulkDealsPage.js
import React, { useEffect, useState } from "react";
import "./BulkDealsPage.css";
import { API_BASE_URL } from "../config";
import WatchlistStar from "./WatchlistStar";
import RefreshButton from "./RefreshButton";

const BulkDealsPage = ({onBack}) => {
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchDeals = () => {
    setLoading(true);
    fetch(`${API_BASE_URL}/bulk-deals`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success" && data.data?.resultData?.deal_data) {
          setDeals(data.data.resultData.deal_data);
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    fetchDeals();
  }, []);

  return (
    <div className="bulk-container">
       {/* HEADER SECTION */}
      <header className="momentum-header">
        <div className="momentum-header-container">
          <div className="logo">
          <img src="images/Final Font Stocks4U1.png" className="logo-text" alt="Stocks4U Logo" />
          </div>

          <div className="momentum-user">
            <RefreshButton 
              onRefresh={fetchDeals} 
              isLoading={loading}
              size="small"
              style={{ marginRight: '10px' }}
            />
            <button className="momentum-back-btn" onClick={onBack}>← Back to Dashboard</button>
          </div>
        </div>
      </header>
     
      <h2 className="bulk-title">Bulk Deals / Block Deals</h2>

      {loading ? (
        <p className="loading">Loading...</p>
      ) : (
        <table className="bulk-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Symbol</th>
              <th>Security Name</th>
              <th>Client Name</th>
              <th>Buy / Sell</th>
              <th>Quantity Traded</th>
              <th>Trade Price</th>
              
            </tr>
          </thead>
          <tbody>
            {deals.map((row, i) => (
              <tr key={i}>
                <td>{row.created_at.split("T")[0]}</td>
                <td className="symbol">
                  <WatchlistStar 
                    stock={{
                      symbol: row.symbol_name,
                      name: row.security_name
                    }}
                  />
                  {row.symbol_name}
                </td>
                <td>{row.security_name}</td>
                <td>{row.client_name}</td>
                <td>{row.type}</td>
                <td>{row.trade_quantity.toLocaleString()}</td>
                <td>{row.trade_price}</td>
                
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default BulkDealsPage;
